import { create } from 'zustand';
import { userManager } from '@providers/userManager';
import { contentApi } from '@api/contentApi';

const INITIAL_STATE = {
    upcomingEventsData: [],
    loadingUpcomingEventsData: false,
    error: null,
};

const useUpcomingEventsStore = create((set, get) => ({
    ...INITIAL_STATE,

    fetchUpcomingEventsData: async () => {
        const state = get();
        if (state.loadingUpcomingEventsData) return;

        set({ loadingUpcomingEventsData: true, error: null });
        try {
            const { location } = userManager.getUserData();
            const response = await contentApi.getEventsList(location);
            if (!response) return [];
            const filteredEvents = response.filter(candidate => candidate.EventDate !== null);
            set({
                upcomingEventsData: filteredEvents,
                loadingUpcomingEventsData: false,
            });
            return filteredEvents;
        } catch (error) {
            const errorMessage = error.response?.data?.error || error.message;
            set({
                error: `Error ${error.response?.status || ''}: ${errorMessage}`,
                loadingUpcomingEventsData: false,
            });
            return state.upcomingEventsData; // Return existing candidates on error
        }
    },
    clearStore: () => set(INITIAL_STATE),
}));

export default useUpcomingEventsStore;
